module.exports = __webpack_public_path__ + "img/bc5ecd3.jpg";